import { cn } from '../cn';

/** Neutral placeholder block. Skeletons mirror the real layout; never use a full-page spinner. */
export function Skeleton({ className }: { className?: string }) {
  return <span aria-hidden="true" className={cn('block animate-pulse rounded-sm bg-surface-muted', className)} />;
}
